module.exports = "<p>\n  dinamic-css works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/dinamic-css/dinamic-css.component.html
// module id = ../../../../../src/app/dinamic-css/dinamic-css.component.html
// module chunks = main